import React from 'react';
import { useTranslation } from 'react-i18next';

interface NotificationFooterProps {
  onClick: () => void;
}

const NotificationFooter = ({ onClick }: NotificationFooterProps) => {
  const { t } = useTranslation('agisviewer');
  return (
    <div className="notification-footer">
      <input
        type="checkbox"
        onChange={onClick}
        className="form__input notification-checkbox"
      />
      {t('disable_notification_type')}
    </div>
  );
};

export default NotificationFooter;
